import AddressInfo from "./components/CreateVendor";
import CreateAccount from "./components/CreateAccount";

export const steps = (onSuccess: () => void) => [
  { Component: CreateAccount, key: "create-account" },
  { Component: AddressInfo, key: "create-vendor", onSuccess },
];
